var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 63,
    viewBox: "0 0 65 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H60C62.7614 0 65 2.23858 65 5V7C65 9.76142 62.7614 12 60 12H5C2.23858 12 0 9.76142 0 7V5Z",
    fill: "#D9D9D9",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22C0 19.2386 2.23858 17 5 17H60C62.7614 17 65 19.2386 65 22V24C65 26.7614 62.7614 29 60 29H5C2.23858 29 0 26.7614 0 24V22Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 39C0 36.2386 2.23858 34 5 34H60C62.7614 34 65 36.2386 65 39V41C65 43.7614 62.7614 46 60 46H5C2.23858 46 0 43.7614 0 41V39Z",
    fill: "#D9D9D9",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 56C0 53.2386 2.23858 51 5 51H45C47.7614 51 50 53.2386 50 56V58C50 60.7614 47.7614 63 45 63H5C2.23858 63 0 60.7614 0 58V56Z",
    fill: "#D9D9D9",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/text_icon.7a4accbd4586094db2eee9dc2df8033f.svg";
export { ForwardRef as ReactComponent };